import { FC, useLayoutEffect, useMemo, useState } from 'react';
import { useAppSelector } from 'hooks';
import { histogramSelector } from 'store/slices/mapV2/tabsReducer/layersReducer/stateSlice/selectors';

import {
  ASIDE_WIDTH,
  SIDEBAR_WIDTH,
} from 'components/Map/MapSidebar/constants';

import { Timeline } from './Timeline';

const RIGHT_OFFSET = 8;

interface MapTimelineProps {
  isSidebarOpen: boolean;
}

export const MapTimeline: FC<MapTimelineProps> = ({ isSidebarOpen }) => {
  const [screenSize, setScreenSize] = useState([0, 0]);
  const histogram = useAppSelector(histogramSelector);

  const leftOffset = isSidebarOpen ? 32 : 8;

  const handleUpdateScreenSize = () => {
    setScreenSize([window.innerWidth, window.innerHeight]);
  };

  const finalLeftOffset = useMemo(() => {
    const initialOffset = ASIDE_WIDTH + leftOffset;
    return isSidebarOpen ? initialOffset + SIDEBAR_WIDTH : initialOffset;
  }, [isSidebarOpen]);

  const finalWidth = useMemo(() => {
    const mapWidth =
      document.getElementById('mapbox-container')?.clientWidth ??
      window.screen.availWidth - ASIDE_WIDTH;

    const initialWidth = isSidebarOpen ? mapWidth - SIDEBAR_WIDTH : mapWidth;
    return initialWidth - RIGHT_OFFSET - leftOffset;
  }, [isSidebarOpen, screenSize]);

  useLayoutEffect(() => {
    window.addEventListener('resize', handleUpdateScreenSize);
    return () => {
      window.removeEventListener('resize', handleUpdateScreenSize);
    };
  }, []);

  return (
    <div
      className="absolute h-14 z-[3] rounded-[10px]"
      style={{
        bottom: 8,
        left: finalLeftOffset,
        width: finalWidth,
      }}
    >
      <div className="w-full h-full px-1 rounded-[inherit]">
        <div className="relative w-full h-full rounded-[inherit] bg-dark border-[1px] border-solid border-tpg_light">
          <Timeline histogram={histogram} />
        </div>
      </div>
    </div>
  );
};
